import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AnlageForm from './pages/AnlageForm';
import AnlageDetails from './pages/AnlageDetails';
import WartungForm from './pages/WartungForm';
import WartungFormVorlage from './pages/WartungFormVorlage';
import QRScanner from './pages/QRScanner';
import VorschriftenInfo from './pages/VorschriftenInfo';
import Kunden from './pages/Kunden';
import KundeForm from './pages/KundeForm';
import KundeDetails from './pages/KundeDetails';
import Anlagen from './pages/Anlagen';
import Import from './pages/Import';
import Benutzerverwaltung from './pages/Benutzerverwaltung';
import VorlagenVerwaltung from './pages/VorlagenVerwaltung';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route path="/" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/anlage/neu" element={
            <ProtectedRoute>
              <AnlageForm />
            </ProtectedRoute>
          } />
          
          <Route path="/anlage/:id" element={
            <ProtectedRoute>
              <AnlageDetails />
            </ProtectedRoute>
          } />
          
          <Route path="/anlage/:id/bearbeiten" element={
            <ProtectedRoute>
              <AnlageForm />
            </ProtectedRoute>
          } />
          
          <Route path="/wartung/neu/:anlageId" element={
            <ProtectedRoute>
              <WartungForm />
            </ProtectedRoute>
          } />
          
          <Route path="/wartung/vorlage/:anlageId" element={
            <ProtectedRoute>
              <WartungFormVorlage />
            </ProtectedRoute>
          } />
          
          <Route path="/scanner" element={
            <ProtectedRoute>
              <QRScanner />
            </ProtectedRoute>
          } />
          
          <Route path="/vorschriften" element={
            <ProtectedRoute>
              <VorschriftenInfo />
            </ProtectedRoute>
          } />
          
          <Route path="/kunden" element={
            <ProtectedRoute>
              <Kunden />
            </ProtectedRoute>
          } />
          
          <Route path="/kunde/neu" element={
            <ProtectedRoute>
              <KundeForm />
            </ProtectedRoute>
          } />
          
          <Route path="/kunde/:id" element={
            <ProtectedRoute>
              <KundeDetails />
            </ProtectedRoute>
          } />
          
          <Route path="/kunde/:id/bearbeiten" element={
            <ProtectedRoute>
              <KundeForm />
            </ProtectedRoute>
          } />
          
          <Route path="/anlagen" element={
            <ProtectedRoute>
              <Anlagen />
            </ProtectedRoute>
          } />
          
          <Route path="/benutzer" element={
            <ProtectedRoute>
              <Benutzerverwaltung />
            </ProtectedRoute>
          } />
          
          <Route path="/vorlagen-verwaltung" element={
            <ProtectedRoute>
              <VorlagenVerwaltung />
            </ProtectedRoute>
          } />
          
          <Route path="/import" element={
            <ProtectedRoute>
              <Import />
            </ProtectedRoute>
          } />
          
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
